import React,{useState, useEffect} from 'react';
import {getAuth, signOut} from 'firebase/auth';
import './css/TopBar.css';
import {Link, useNavigate} from "react-router-dom" ;
import TopCornerUserPopup from "./TopCornerUserPopup";
import RallyGetDataFromDB from "./RallyGetDataFromDB";
import RallyUpdateDB from "./RallyUpdateDB"

//redux
import { useSelector, useDispatch} from 'react-redux';
import {setLoginStatus, setPhoto, setUserName,setReduxUserID } from "./redux/isLoggedIn"
import {setFirstAppLoad } from "./redux/firstAppLoad"

//FirebaseError
import { db } from './firebase';
import { addDoc,deleteDoc, doc, getDocs, collection, query, where,serverTimestamp, getDoc, setDoc } from 'firebase/firestore';

 const TopBar = React.memo(props => {
    const auth = getAuth();
    const user = auth.currentUser;
    let navigate = useNavigate();
    let dispatch = useDispatch();


    //console.log("logged in? : ", auth);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [userID, setUserID] = useState(''); 
    
    const [loggedInCookie, setLoginCookieStatus] = useState(window.localStorage.getItem('loggedIn')); 
    const [popupIsOpen, setPopupIsOpen] = useState(false); //not bool bc getting some bullsuit error
    const [firstLoad, setFirstLoad] = useState(true);
    const [closePopupHack,setClosePopupHack] = useState(false);

    const reduxFirstAppLoad = useSelector((state) => state.firstAppLoad.reduxFirstAppLoad);
    const reduxIsLoggedIn = useSelector((state) => state.isLoggedIn.reduxIsLoggedIn);
    const reduxUserName = useSelector((state) => state.isLoggedIn.reduxUserName);
    const reduxUserPhoto = useSelector((state) => state.isLoggedIn.reduxUserPhoto);
    const reduxUserID = useSelector((state) => state.isLoggedIn.reduxUserID);
    const reduxFlameOn = useSelector((state) => state.rallyTracker.reduxFlameOn);

  

    const reduxRallyNumber = useSelector((state) => state.rallyTracker.reduxRallyNumber);




    /////get a single document 'headshot'
    const headShotGrab = () =>{
      const userHeadshotRef = doc(db,"users",reduxUserID);
      getDoc(userHeadshotRef)
      .then(function(dataReturned){
          
          if(dataReturned.data().headshot != undefined){
              console.log(dataReturned.data().headshot);
              dispatch(setPhoto(dataReturned.data().headshot)); 
          }
          else{
              dispatch(setPhoto("http://nick-georgiou.com/languageAppIcons/genericHeadShot.jpg")); 
          }  
      })
  }


    var userName;
    var userImage;
    
    if(auth.currentUser){
      userName = user.displayName;
      userImage = reduxUserPhoto;

    }
    else{
      userImage = "topBar-blank";
    }

    auth.onAuthStateChanged( (user) => {
      if(user){
       userName = user.displayName;
        userImage = user.photoURL;
        setLoginCookieStatus(true);
        dispatch(setReduxUserID(user.uid));
        dispatch(setUserName(userName));
        dispatch(setLoginStatus(true));
        //dispatch(setPhoto("http://nick-georgiou.com/languageAppIcons/genericHeadShot.jpg"));

      }
      else{
        setPopupIsOpen(false);
       //setClosePopupHack(false);
      }
    })


    const openPopup = () => {
      if(popupIsOpen === false && reduxUserName != ''){
        setPopupIsOpen(true);
      }
      else{
        setPopupIsOpen(false);
        setClosePopupHack(true);
        setTimeout(function(){
          setClosePopupHack(false);
        },300);
      }
    }




  ////empty local storage values are null, which is reading as 'true' below when we check for the topbar color
  ////here we check when the app first starts. If it's null, change it to 'false'
  ////make sure to set it to false on singOut() too
    useEffect(() => {

      if(window.localStorage.getItem('loggedIn') != true && window.localStorage.getItem('loggedIn') != 'true'){
        setLoginCookieStatus(false);
      }
     // dispatch

    //  console.log('reduxUserPhoto: ' + reduxUserPhoto);
    //  console.log('reduxUserID: ' + reduxUserID);
    //  console.log('reduxUserName: ' + reduxUserName);

     headShotGrab();


    }, [reduxUserID])



      const logOut = () => {
        //localStorage
        window.localStorage.setItem('loggedIn', false);
        window.localStorage.setItem('username', '');
        window.localStorage.setItem('userPhoto', "");
        window.localStorage.setItem('userID', '');  

        setPopupIsOpen(false);

          //from firebase
          signOut(auth)        
          .then( ()=> {
            console.log("the user has been logged out");
            setUserID('');
            setLoginCookieStatus(false);
            window.localStorage.setItem('loggedIn', false);

            navigate('/app/');
          })
          .catch( (err) =>{
              console.log(err.message);
          })
      }

      const goToStart = () => {
          if(loggedInCookie){
            navigate("/app/home");
          }
          else{
            navigate("/app/");
          }
      }


    return (
        <div className='topBarWide' style={{ backgroundColor: loggedInCookie? '#000': '#000' }}>
            
            {/* //have this here bc the topbar is always present. So from here we can always grab the 
            rally data and put it in redux. This will set redux w the DB data at the start of the app */}
            <RallyGetDataFromDB />
            <RallyUpdateDB />


            <div className='topBarContainer'>
              
              {popupIsOpen == true &&
                <TopCornerUserPopup popupIsOpen = {popupIsOpen} setPopupIsOpen={setPopupIsOpen} setClosePopupHack={setClosePopupHack}  />
              }

             
              <div className={closePopupHack ? 'closePopupHack closeClass': "hideCloseHack"}></div>
              





                <div className='topBarContent'> 

                  <img 
                    className={reduxIsLoggedIn ? 'logo' : 'logoCentered' }
                    src='http://nick-georgiou.com/languageAppIcons/gringoLogo.jpg' 
                    onClick = { goToStart } 
                  />


                  <div className={ loggedInCookie && reduxIsLoggedIn  ? 'loggedInImageArea': 'loggedOutImageArea' }>
                    <div 
                      className='iconImage' 
                      style={{backgroundImage:"url(" + reduxUserPhoto + ")"}} 
                      onClick={openPopup}  
                    >
                    </div>
                    <div className='rallyDisplay'>
                      <p className={reduxFlameOn ? 'rallyTextFade' : ''}>{reduxRallyNumber}</p>
                    </div>

                    <div className='rallyFlameHolder'>
                      <div className={reduxFlameOn ? 'flameOnBall flameBallOne' : 'flameOnBall'}></div>
                      <div className={reduxFlameOn ? 'flameOnBall flameBallTwo' : 'flameOnBall'}></div>
                      <div className={reduxFlameOn ? 'flameOnBall flameBallThree' : 'flameOnBall'}></div>
                      <div className={reduxFlameOn ? 'fadingFire flameOn' : 'fadingFire '}></div>
                      <img 
                        src='http://nick-georgiou.com/languageAppIcons/rallyFlame.png'  
                        className={''} 
                      />
                    </div>

                  </div>
          
                </div> {/* end topBarContainer, limiting the width of the content to 500 */} 

            </div>
        </div>  
    )
})


export default TopBar;